import EmployeeStore from './employeeStore';
import PlanStore from './planStore';
import FilterStore from './filterStore';
import ShiftStore from './shiftStore';
import DayStore from './dayStore';

export default {
  employeeStore: new EmployeeStore(),
  planStore: new PlanStore(),
  filterStore: new FilterStore(),
  shiftStore: new ShiftStore(),
  dayStore: new DayStore(),
};



// WEBPACK FOOTER //
// ./src/store/index.js